<div
  class="ui segment conversation-card"
  appPadding="24px"
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="20px"
  (click)="viewMessages(conversation)"
  [ngClass]="{ 'selected-conversation': isSelected == conversation.sessionId }"
>
  <div class="icon-section" fxFlex="14">
    <span class="ui huge grey circular label">{{
      getAcronym(conversation.subtopic.topic.topic)
    }}</span>
  </div>
  <div
    class="conversation-details-section"
    fxFlex="78"
    fxLayout="column"
    fxLayoutGap="8px"
  >
    <h3 class="ui header">{{ conversation.subtopic.topic.topic }}</h3>
    <p class="service-description">{{ conversation.subtopic.subtopic }}</p>
    <p class="status-time">
      <span
        >Last Activity:
        {{ conversation.lastActivity | date: "h:mm a, EEEE d MMMM y" }}</span
      >
    </p>
  </div>
  <div class="comment-count-section" fxFlex="8">
    <span class="ui large blue circular label">{{
      conversation.countMetadata.totalComments -
        conversation.countMetadata.commentsRead || 0
    }}</span>
  </div>
</div>
